import React from "react";
import {
  FileText, ShieldCheck, CalendarDays, Building2, IdCard, Hash, Home, Mail, Landmark, List
} from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

const yesNo = (v) => (v ? "Tak" : v === false ? "Nie" : "—");

export default function WhiteListSection({ data }) {
  const w = data || {}; // expects result.white_list

  // Accounts object: { "Bank Name": ["acc1", "acc2", ...], ... }
  const accountsEntries = w?.accounts && typeof w.accounts === "object"
    ? Object.entries(w.accounts)
    : [];

  return (
    <Sekcja
      title="VAT i Biała lista"
      icon={ShieldCheck}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      <div className="sectionGrid">
        {/* Left column */}
        <div>
          <RowIcon icon={CalendarDays} label="Ostatnia aktualizacja">
            {w?.last_update || <em>—</em>}
          </RowIcon>
          <RowIcon icon={CalendarDays} label="Data sprawdzenia">
            {w?.last_check || <em>—</em>}
          </RowIcon>
          <RowIcon icon={CalendarDays} label="Data statusu">
            {w?.date_status || <em>—</em>}
          </RowIcon>

          <RowIcon icon={IdCard} label="NIP">
            {mono(w?.nip)}
          </RowIcon>
          <RowIcon icon={Hash} label="REGON">
            {mono(w?.regon)}
          </RowIcon>
          <RowIcon icon={Hash} label="KRS">
            {mono(w?.krs)}
          </RowIcon>
          <RowIcon icon={IdCard} label="PESEL">
            {mono(w?.pesel)}
          </RowIcon>
          <RowIcon icon={Building2} label="Nazwa">
            {w?.name || <em>—</em>}
          </RowIcon>
          <RowIcon icon={Hash} label="Id żądania">
            {mono(w?.request_id)}
          </RowIcon>
        </div>

        {/* Right column */}
        <div>
          <RowIcon icon={ShieldCheck} label="Status VAT">
            {w?.vat_status || <em>—</em>}
          </RowIcon>
          <RowIcon icon={Home} label="Adres wykonywania działalności">
            {w?.working_address || <em>—</em>}
          </RowIcon>
          <RowIcon icon={Home} label="Adres zamieszkania / siedziby">
            {w?.residence_address || <em>—</em>}
          </RowIcon>
          <RowIcon icon={Mail} label="Kod pocztowy">
            {mono(w?.postcode)}
          </RowIcon>

          <RowIcon icon={CalendarDays} label="Data rejestracji (legalna)">
            {w?.registration_legal_date || <em>—</em>}
          </RowIcon>
          <RowIcon icon={CalendarDays} label="Data odmowy rejestracji">
            {w?.registration_denial_date || <em>—</em>}
          </RowIcon>
          <RowIcon icon={FileText} label="Podstawa odmowy rejestracji">
            {w?.registration_denial_basis || <em>—</em>}
          </RowIcon>

          <RowIcon icon={CalendarDays} label="Data wykreślenia">
            {w?.removal_date || <em>—</em>}
          </RowIcon>
          <RowIcon icon={FileText} label="Podstawa wykreślenia">
            {w?.removal_basis || <em>—</em>}
          </RowIcon>

          <RowIcon icon={CalendarDays} label="Data przywrócenia">
            {w?.restoration_date || <em>—</em>}
          </RowIcon>
          <RowIcon icon={FileText} label="Podstawa przywrócenia">
            {w?.restoration_basis || <em>—</em>}
          </RowIcon>

          <RowIcon icon={ShieldCheck} label="Wirtualny rachunek">
            {yesNo(w?.virtual_account)}
          </RowIcon>
        </div>

        {/* Full-width: Rachunki bankowe (grupowane wg banku) */}
        <div className="fullRow">
          <RowIcon icon={Landmark} label="Rachunki bankowe">
            {accountsEntries.length > 0 ? (
              <div style={{ display: "grid", gap: 8 }}>
                {accountsEntries.map(([bank, arr], idx) => (
                  <div key={idx} style={{ display: "grid", gap: 6 }}>
                    <div style={{ fontWeight: 700 }}>{bank || "—"}</div>
                    <div style={{ display: "grid", gap: 4 }}>
                      {(arr || []).map((acc, j) => (
                        <code
                          key={j}
                          style={{
                            background: "#f3f4f6",
                            padding: "4px 6px",
                            borderRadius: 8,
                            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                            fontSize: 12,
                          }}
                        >
                          {acc}
                        </code>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <em>Brak rachunków na białej liście.</em>
            )}
          </RowIcon>
        </div>
      </div>
    </Sekcja>
  );
}
